const englishTranslations = {
  assessmentReminderPopup: {
    basdaiReminderPopupMsg:
      "It's time to complete your BASDAI pain score assessment for tomorrow's appointment. ",
    basfiReminderPopupMsg:
      "It's time to complete your BASFI pain score assessment for tomorrow's appointment. ",
    rapid3ReminderPopupMsg:
      "It's time to complete your RAPID3 pain score assessment for tomorrow's appointment. ",
    common: {
      dismiss: "Dismiss",
      close: "Close",
      continue: "Continue",
    },
  },
};

const marathiTranslations = {
  assessmentReminderPopup: {
    basdaiReminderPopupMsg:
      "उद्या अपॉइंटमेंटसाठी तुमचा BASDAI पेन स्कोअर टेस्ट पूर्ण करण्याची वेळ आली आहे।",
    basfiReminderPopupMsg:
      "उद्या अपॉइंटमेंटसाठी तुमचा BASFI पेन स्कोअर टेस्ट पूर्ण करण्याची वेळ आली आहे।",
    rapid3ReminderPopupMsg:
      "उद्या अपॉइंटमेंटसाठी तुमचा RAPID3 पेन स्कोअर टेस्ट पूर्ण करण्याची वेळ आली आहे।",
    common: {
      dismiss: "Dismiss",
      close: "Close",
      continue: "Continue",
    },
  },
};

const hindiTranslations = {
  assessmentReminderPopup: {
    basdaiReminderPopupMsg:
      "आपकी कल की अपॉइंटमेंट के लिए अब BASDAI पेन स्कोर टेस्ट पूरा करने का समय है।",
    basfiReminderPopupMsg:
      "आपकी कल की अपॉइंटमेंट के लिए अब BASFI पेन स्कोर टेस्ट पूरा करने का समय है।",
    rapid3ReminderPopupMsg:
      "आपकी कल की अपॉइंटमेंट के लिए अब RAPID3 पेन स्कोर टेस्ट पूरा करने का समय है।",
    common: {
      dismiss: "Dismiss",
      close: "Close",
      continue: "Continue",
    },
  },
};
export const translations = {
  EN: englishTranslations,
  MR: marathiTranslations,
  HI: hindiTranslations,
};
